export default __webpack_public_path__ + "static/media/blackVehicle.35c139d9.png";